import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useParams } from "react-router-dom";

import AdminOnly from "~/components/AdminOnly";
import useActiveService from "./useActiveService";
import ServiceCards from "./ServiceCards";
import ConfimModal from "./ConfimModal";
import Notification from "../notification/Notification";
import API_ROUTES from "../../../api-routes";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";

import "./services.scss";

export default function ActiveServices() {
  const { id } = useParams();

  const {
    isEdit,
    isLoading,
    activeServices,
    entityservices,
    isAudit,
    isSaveDisabled,
    isUpdateLoading,
    isConfirmModal,
    successMessage,
    setSuccessMessage,
    setIsConfirmModal,
    handleEditClick,
    handleDiscardClick,
    setIsAudit,
    handleChange,
    removeService,
    handleSave,
  } = useActiveService();
  const auditLabels = () => {
    return {
      create: "Service Added",
      update: "Information Updated",
      delete: "Service Removed",
    };
  };
  return (
    <div className="service-container flex justify-content-center">
      <Card className="gen-card h-full w-full">
        <div className="entity-plus-container pb-4 flex justify-content-between  align-items-center formgrid grid grid-nogutter">
          <div>
            <p className="service-heading">Active Services</p>
            <p className="service-sub-heading">
              Manage all contracted services for this entity.
            </p>
          </div>

          <AdminOnly>
            <div className="flex">
              {isEdit ? (
                <div className="flex gap-2">
                  <button
                    className="discard-button"
                    onClick={handleDiscardClick}
                  >
                    Discard
                  </button>

                  <Button
                    className={`save-btn ${isSaveDisabled && "disable"}`}
                    loading={isUpdateLoading}
                    onClick={handleSave}
                    disabled={isUpdateLoading || isSaveDisabled}
                  >
                    {!isUpdateLoading && "Save Changes"}
                  </Button>
                </div>
              ) : (
                <>
                  <button
                    className="add-new-button"
                    onClick={() => setIsAudit(!isAudit)}
                  >
                    View History
                    <span className="pi pi-history mb-1 ml-2" />
                  </button>

                  <button
                    className="edit-button"
                    onClick={() => {
                      handleEditClick();
                    }}
                  >
                    Edit
                    <span className="pi pi-pencil text-xs ml-2"></span>
                  </button>
                </>
              )}
            </div>
          </AdminOnly>
        </div>
        {successMessage && (
          <div className="grid w-full grid-nogutter mb-3">
            <Notification
              successMessage={successMessage}
              setSuccessMessage={setSuccessMessage}
            />
          </div>
        )}
        <div className="grid w-full grid-nogutter">
          <div className="col-12">
            <ServiceCards
              serviceList={entityservices}
              activeServices={activeServices}
              isLoading={isLoading}
              handleChange={handleChange}
              isEdit={isEdit}
            />
          </div>
        </div>

        <ConfimModal
          visible={isConfirmModal}
          closeModal={() => setIsConfirmModal(false)}
          deleteSevice={removeService}
        />
        {isAudit && (
          <AuditSidebar
            heading="Active services"
            endpoint={API_ROUTES.FETCH_SERVICE_AUDIT}
            id={id}
            labels={auditLabels}
            setSidebarToggle={setIsAudit}
            sidebarToggle={isAudit}
          />
        )}
      </Card>
    </div>
  );
}
